'use strict';

import angular from 'angular';
import template from './modal.pug';

const NewAccountModalSvc = [
  'ModalSvc', 'LoaderSvc', '$location', 'StripeSvc',
  function(ModalSvc, LoaderSvc, $location, StripeSvc) {
    function open() {
      var modalInstance;
      var modalvm = {};
      var formvm = {
        // eslint-disable-next-line camelcase
        account_holder_type: 'individual'
      };

      //////////////////////////////////////////////////////////////////////////
      // Testing Data
      //////////////////////////////////////////////////////////////////////////
      var url = $location.absUrl();
      var isTestingEnv = url.toLowerCase().includes('sandbox')
        || url.toLowerCase().includes('staging')
        || url.toLowerCase().includes('localhost');
      if(isTestingEnv) {
        var baseAccount = {
          // eslint-disable-next-line camelcase
          routing_number: 110000000,
          country: 'US',
          currency: 'USD',
          // eslint-disable-next-line camelcase
          account_holder_type: 'individual'
        };

        /**
         * https://stripe.com/docs/testing#managed-accounts
         */
        var testAccounts = [
          // good
          {
            // eslint-disable-next-line camelcase
            account_number: '000123456789',
            // eslint-disable-next-line camelcase
            account_holder_name: 'Fake Account - Success (Automatic)',
            verificationMethod: 'automatic',
            display: 'success'
          },
          {
            // eslint-disable-next-line camelcase
            account_number: '000123456789',
            // eslint-disable-next-line camelcase
            account_holder_name:
              'Fake Account - Success (Microdeposits: Descriptor Code)',
            verificationMethod: 'microdeposits',
            display: 'success'
          },
          {
            // eslint-disable-next-line camelcase
            account_number: '000123456789',
            // eslint-disable-next-line camelcase
            account_holder_name:
              'Fake Account - Success (Microdeposits: Amounts)',
            verificationMethod: 'microdeposits',
            display: 'success'
          },
          // bad
          {
            // eslint-disable-next-line camelcase
            account_number: '000111111116',
            // eslint-disable-next-line camelcase
            account_holder_name: 'Fake Account - No Account',
            display: 'error'
          },
          {
            // eslint-disable-next-line camelcase
            account_number: '000111111113',
            // eslint-disable-next-line camelcase
            account_holder_name: 'Fake Account - Account Closed',
            display: 'error'
          },
          {
            // eslint-disable-next-line camelcase
            account_number: '000222222227',
            // eslint-disable-next-line camelcase
            account_holder_name: 'Fake Account - Insufficient Funds',
            display: 'error'
          },
          {
            // eslint-disable-next-line camelcase
            account_number: '000333333335',
            // eslint-disable-next-line camelcase
            account_holder_name: 'Fake Account - Not Authorized',
            display: 'error'
          }
        ];

        testAccounts = testAccounts.map(function(c) {
          return angular.extend({}, baseAccount, c);
        });
        // eslint-disable-next-line camelcase
        testAccounts.push({ account_holder_name: 'Reset' });
        modalvm.testAccounts = testAccounts;

        modalvm.populateAccount = function(c) {
          modalvm.formvm = c;
          if(c.account_holder_name === 'Reset') {
            modalvm.formvm = {};
          }
        };
      }

      //////////////////////////////////////////////////////////////////////////
      // Account Form Setup
      //////////////////////////////////////////////////////////////////////////
      // submit

      modalvm.submit = async function() {
        LoaderSvc.start();
        var newAccount = modalvm.formvm;

        if(
          !newAccount.routing_number
          || !newAccount.account_number
          || !newAccount.account_holder_name
        ) {
          return LoaderSvc.stopError('Missing Bank Account Details');
        }

        try {
          // 1. Create a SetupIntent for US bank account verification
          /* eslint-disable camelcase */
          const setupIntentData = {
            usage: 'off_session',
            payment_method_types: ['us_bank_account']
          };

          if(isTestingEnv) {
            var verificationMethod = newAccount.verificationMethod
              || newAccount.verification_method
              || 'automatic';
            setupIntentData.payment_method_options = {
              us_bank_account: {
                verification_method: verificationMethod
              }
            };
          }

          const setupIntentRes = await StripeSvc
            .createBankAccountSetupIntent(setupIntentData);
          /* eslint-enable camelcase */

          if(!setupIntentRes || !setupIntentRes.client_secret) {
            LoaderSvc.stopError('Could not start bank account setup.');
            return;
          }

          const stripe = StripeSvc.getStripeInstance();

          // 2. Confirm the SetupIntent with bank account details
          /* eslint-disable camelcase */
          const {error, setupIntent} = await stripe.confirmSetup({
            clientSecret: setupIntentRes.client_secret,
            confirmParams: {
              payment_method_data: {
                type: 'us_bank_account',
                us_bank_account: {
                  routing_number: String(newAccount.routing_number),
                  account_number: String(newAccount.account_number),
                  account_holder_type:
                    String(newAccount.account_holder_type || 'individual')
                },
                billing_details: {
                  name: String(newAccount.account_holder_name)
                }
              }
            },
            redirect: 'if_required'
          });
          /* eslint-enable camelcase */

          if(error) {
            console.error(
              '[New Account Modal] SetupIntent confirmation error:', error);
            LoaderSvc.stopError(
              error.message || 'Invalid Bank Account');
            return;
          }

          var verifyWithMicrodeposits = setupIntent
            && setupIntent.next_action
            && setupIntent.next_action.type === 'verify_with_microdeposits'
            && setupIntent.next_action.verify_with_microdeposits;

          modalvm.microdepositType = verifyWithMicrodeposits
            && verifyWithMicrodeposits.microdeposit_type
            ? verifyWithMicrodeposits.microdeposit_type
            : null;
          modalvm.isInstantVerified = setupIntent
            && setupIntent.status === 'succeeded';

          LoaderSvc.stopSuccess(
            modalvm.isInstantVerified
              ? 'Bank Account Added and verified by Stripe.'
              : 'Bank Account Added! Please verify microdeposits in your '
                + 'bank account.');
          modalvm.accountCreatedOpt2 = true;
          // Update buttons
          buttons.splice(0, 1);
          buttons[0].text = 'Close';
          buttons[0].click = function() {
            modalInstance.close(setupIntent);
          };
        } catch(err) {
          console.error('[New Account Modal] Error:', err);
          LoaderSvc.stopError(err.message || 'Error adding bank account.');
        }
      };


      //   // for future update to new bank account setup intent approach
      //   modalvm.submit_new = async function() {
      //     LoaderSvc.start();
      //     var newAccount = modalvm.formvm;
      //
      //     if(
      //       !newAccount.routing_number
      //       || !newAccount.account_number
      //       || !newAccount.account_holder_name
      //     ) {
      //       return LoaderSvc.stopError('Missing Bank Account Details');
      //     }
      //
      //     try {
      //       // 1. Request a SetupIntent from your backend
      //       const setupIntentRes = await
      //         StripeSvc.createBankAccountSetupIntent();
      //       if(
      //         !setupIntentRes
      //         || !setupIntentRes.client_secret
      //       ) {
      //         LoaderSvc.stopError('Could not start bank account setup.');
      //         return;
      //       }
      //
      //       const stripe = StripeSvc.getStripeInstance();
      //       // 2. Confirm the SetupIntent and collect bank account details
      //       const {error, setupIntent} = await
      //         stripe.confirmSetup(
      //           setupIntentRes.client_secret,
      //           {
      //             payment_method: {
      //               us_bank_account: {
      //                 routing_number: String(newAccount.routing_number),
      //                 account_number: String(newAccount.account_number),
      // // eslint-disable-next-line camelcase
      // account_holder_type: String(
      //                   newAccount.account_holder_type || 'individual'
      //                 )
      //               },
      //               billing_details: {
      //                 name: String(newAccount.account_holder_name)
      //               }
      //             }
      //           }
      //         );
      //
      //       if(error) {
      //         LoaderSvc.stopError(error.message || 'Invalid Bank Account');
      //         return;
      //       }
      //
      //       LoaderSvc.stopSuccess(
      //         'Bank Account Added! Please verify micro-deposits in your '
      //         + 'bank account.'
      //       );
      //       modalvm.accountCreatedOpt2 = true;
      //       buttons.splice(0, 1);
      //       buttons[0].text = 'Close';
      //       buttons[0].click = function() {
      //         modalInstance.close(setupIntent);
      //       };
      //     } catch (err) {
      //       LoaderSvc.stopError(
      //         err.message || 'Error adding bank account.'
      //       );
      //     }
      //   };

      function onCancel() {
        modalInstance.dismiss();
      }

      var buttons = [
        {
          classes: 'btn-primary',
          text: 'Add Bank Account',
          click: modalvm.submit
        },
        {
          classes: 'btn-default',
          text: 'Cancel',
          click: onCancel
        }
      ];

      var modalScope = {modalvm: angular.extend(modalvm, {
        title: 'New Bank Account',
        dismissable: true,
        formvm,
        buttons
      })};

      var options = {template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];

export default NewAccountModalSvc;
